// Auto-generated from _external-variables.scss
export const tsThemeVars = {
  '--ts-var-root-color': 'initial',
  '--ts-var-root-background': 'initial',
  '--ts-var-root-font-family': 'initial',
  '--ts-var-root-text-transform': 'initial',
  '--ts-var-application-color': 'initial',
  '--ts-var-root-secondary-color': 'initial',
  '--ts-var-nav-color': 'var(--ts-var-root-color)',
  '--ts-var-nav-background': 'initial',
  '--ts-var-search-data-button-font-color': 'var(--ts-var-root-color)',
  '--ts-var-search-data-button-background': 'initial',
  '--ts-var-search-data-button-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-nav-action-item-background': 'initial',
  '--ts-var-nav-action-item-border-color': 'initial',
  '--ts-var-nav-action-item-border-secondary-color': 'initial',
  '--ts-var-nav-action-item-placeholder-color': 'initial',
  '--ts-var-left-nav-background': 'initial',
  '--ts-var-left-nav-active-tab-background': 'initial',
  '--ts-var-left-nav-active-tab-border-color': 'initial',
  '--ts-var-left-nav-section-title-color': 'initial',
  '--ts-var-left-nav-item-color': 'initial',
  '--ts-var-left-nav-item-selection-color': 'initial',
  '--ts-var-left-nav-item-selection-background': 'initial',
  '--ts-var-search-bar-text-font-color': 'var(--ts-var-root-color)',
  '--ts-var-search-bar-text-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-search-bar-text-font-style': 'initial',
  '--ts-var-search-bar-background': 'initial',
  '--ts-var-search-auto-complete-background': 'initial',
  '--ts-var-search-auto-complete-font-color': 'var(--ts-var-root-color)',
  '--ts-var-search-auto-complete-subtext-font-color': 'initial',
  '--ts-var-search-navigation-button-background': 'initial',
  '--ts-var-search-bar-navigation-help-text-background': 'initial',
  '--ts-var-search-bar-auto-complete-hover-background': 'initial',
  '--ts-var-spotter-input-background': 'initial',
  '--ts-var-spotter-prompt-background': 'initial',
  '--ts-var-answer-data-panel-background-color': 'initial',
  '--ts-var-answer-view-table-chart-switcher-background': 'initial',
  '--ts-var-answer-view-table-chart-switcher-active-background': 'initial',
  '--ts-var-answer-edit-panel-background-color': 'initial',
  '--ts-var-button-border-radius': 'initial',
  '--ts-var-button--icon-border-radius': 'initial',
  '--ts-var-button--primary-color': 'var(--ts-var-root-color)',
  '--ts-var-button--primary-background': 'initial',
  '--ts-var-button--primary--hover-background': 'initial',
  '--ts-var-button--primary--font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-button--primary--active-background': 'initial',
  '--ts-var-button--secondary-color': 'var(--ts-var-root-color)',
  '--ts-var-button--secondary-background': 'initial',
  '--ts-var-button--secondary--hover-background': 'initial',
  '--ts-var-button--secondary--font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-button--secondary--active-background': 'initial',
  '--ts-var-button--tertiary-color': 'var(--ts-var-root-color)',
  '--ts-var-button--tertiary-background': 'initial',
  '--ts-var-button--tertiary--hover-background': 'initial',
  '--ts-var-button--tertiary--active-background': 'initial',
  '--ts-var-sage-bar-header-background-color': 'initial',
  '--ts-var-source-selector-background-color': 'initial',
  '--ts-var-sage-search-box-font-color': 'initial',
  '--ts-var-sage-search-box-background-color': 'initial',
  '--ts-var-sage-embed-background-color': 'initial',
  '--ts-var-sage-seed-questions-background': 'initial',
  '--ts-var-sage-seed-questions-font-color': 'initial',
  '--ts-var-sage-seed-questions-hover-background': 'initial',
  '--ts-var-source-selector-hover-color': 'initial',
  '--ts-var-ai-gradient-color': 'initial',
  '--ts-var-answer-chart-select-background': 'initial',
  '--ts-var-answer-chart-hover-background': 'initial',
  '--ts-var-chip-border-radius': 'initial',
  '--ts-var-chip-title-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-chip-box-shadow': 'initial',
  '--ts-var-chip-background': 'initial',
  '--ts-var-chip-color': 'var(--ts-var-root-color)',
  '--ts-var-chip--hover-background': 'initial',
  '--ts-var-chip--hover-color': 'var(--ts-var-root-color)',
  '--ts-var-chip--active-background': 'initial',
  '--ts-var-chip--active-color': 'initial',
  '--ts-var-axis-title-color': 'var(--ts-var-root-color)',
  '--ts-var-axis-title-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-axis-data-label-color': 'var(--ts-var-root-color)',
  '--ts-var-axis-data-label-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-menu-color': 'var(--ts-var-root-color)',
  '--ts-var-menu-background': 'initial',
  '--ts-var-menu-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-menu-text-transform': 'var(--ts-var-root-text-transform)',
  '--ts-var-menu--hover-background': 'initial',
  '--ts-var-menu-seperator-background': 'initial',
  '--ts-var-menu-selected-text-color': 'initial',
  '--ts-var-dialog-body-background': 'initial',
  '--ts-var-dialog-body-color': 'var(--ts-var-root-color)',
  '--ts-var-dialog-header-background': 'initial',
  '--ts-var-dialog-header-color': 'var(--ts-var-root-color)',
  '--ts-var-dialog-footer-background': 'initial',
  '--ts-var-list-selected-background': 'initial',
  '--ts-var-list-hover-background': 'initial',
  '--ts-var-segment-control-hover-background': 'initial',
  '--ts-var-home-watchlist-selected-text-color': 'initial',
  '--ts-var-home-card-color': 'var(--ts-var-root-color)',
  '--ts-var-home-favorite-suggestion-card-text-color': 'initial',
  '--ts-var-home-favorite-suggestion-card-text-font-color': 'initial',
  '--ts-var-home-favorite-suggestion-card-background': 'initial',
  '--ts-var-home-favorite-suggestion-card-icon-color': 'initial',
  '--ts-var-checkbox-error-border': 'initial',
  '--ts-var-checkbox-border-color': 'initial',
  '--ts-var-checkbox-hover-border': 'initial',
  '--ts-var-checkbox-active-color': 'initial',
  '--ts-var-checkbox-checked-color': 'initial',
  '--ts-var-checkbox-checked-disabled': 'initial',
  '--ts-var-checkbox-highlighted-hover-color': 'initial',
  '--ts-var-checkbox-background-color': 'initial',
  '--ts-var-viz-tile-height': 'initial',
  '--ts-var-liveboard-layout-background': 'var(--ts-var-root-background)',
  '--ts-var-liveboard-layout-title-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-layout-title-fontsize': 'initial',
  '--ts-var-liveboard-header-background': 'var(--ts-var-viz-background)',
  '--ts-var-liveboard-header-fontsize': 'initial',
  '--ts-var-liveboard-header-font-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-tile-border-color': 'var(--ts-var-viz-border-color)',
  '--ts-var-liveboard-tile-background': 'var(--ts-var-viz-background)',
  '--ts-var-liveboard-tile-border-radius': 'var(--ts-var-viz-border-radius)',
  '--ts-var-liveboard-tile-padding': 'initial',
  '--ts-var-liveboard-tile-table-header-background': 'initial',
  '--ts-var-liveboard-group-padding': 'initial',
  '--ts-var-liveboard-group-title-padding': 'initial',
  '--ts-var-liveboard-group-title-font-size': 'initial',
  '--ts-var-liveboard-group-title-font-weight': 'initial',
  '--ts-var-liveboard-group-tile-title-font-size': 'initial',
  '--ts-var-liveboard-group-tile-title-font-weight': 'initial',
  '--ts-var-liveboard-group-description-font-size': 'initial',
  '--ts-var-liveboard-group-description-font-weight': 'initial',
  '--ts-var-liveboard-group-tile-border': 'initial',
  '--ts-var-liveboard-group-tile-padding': 'initial',
  '--ts-var-liveboard-answer-viz-padding': 'initial',
  '--ts-var-liveboard-group-background': 'var(--ts-var-viz-background)',
  '--ts-var-liveboard-group-border-color': 'var(--ts-var-viz-border-color)',
  '--ts-var-liveboard-notetitle-heading-font-color': 'initial',
  '--ts-var-liveboard-notetitle-body-font-color': 'initial',
  '--ts-var-liveboard-group-title-font-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-group-description-font-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-group-tile-title-font-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-group-tile-background': 'var(--ts-var-viz-background)',
  '--ts-var-liveboard-chip-background': 'var(--ts-var-chip-background)',
  '--ts-var-liveboard-chip-color': 'var(--ts-var-chip-color)',
  '--ts-var-liveboard-chip--hover-background': 'var(--ts-var-chip--hover-background)',
  '--ts-var-liveboard-chip--hover-color': 'var(--ts-var-chip--hover-color)',
  '--ts-var-liveboard-chip--active-background': 'var(--ts-var-chip--active-background)',
  '--ts-var-liveboard-chip--active-color': 'var(--ts-var-chip--active-color)',
  '--ts-var-side-panel-width': 'initial',
  '--ts-var-liveboard-edit-bar-background': 'initial',
  '--ts-var-liveboard-dual-column-breakpoint': 'initial',
  '--ts-var-liveboard-single-column-breakpoint': 'initial',
  '--ts-var-liveboard-cross-filter-layout-background': 'initial',
  '--ts-var-liveboard-tab-active-border-color': 'initial',
  '--ts-var-liveboard-tab-hover-color': 'initial',
  '--ts-var-liveboard-tile-title-fontsize': 'initial',
  '--ts-var-liveboard-tile-title-fontweight': 'initial',
  '--ts-var-liveboard-tile-description-font-weight': "'initial'",
  '--ts-var-liveboard-tile-description-opacity': 'initial',
  '--ts-var-parameter-chip-background': 'initial',
  '--ts-var-parameter-chip-text-color': 'initial',
  '--ts-var-parameter-chip-hover-background': 'initial',
  '--ts-var-parameter-chip-hover-text-color': 'initial',
  '--ts-var-parameter-chip-active-background': 'initial',
  '--ts-var-parameter-chip-active-text-color': 'initial',
  '--ts-var-liveboard-header-action-button-background':
    'var(--ts-var-button--secondary-background)',
  '--ts-var-liveboard-header-action-button-font-color': 'var(--ts-var-button--secondary-color)',
  '--ts-var-liveboard-header-action-button-hover-color':
    'var(--ts-var-button--secondary--hover-background)',
  '--ts-var-liveboard-header-action-button-active-color':
    'var(--ts-var-button--secondary--active-background)',
  '--ts-var-liveboard-header-badge-background': 'var(--ts-var-button--primary-background)',
  '--ts-var-liveboard-header-badge-font-color': 'var(--ts-var-button--primary-color)',
  '--ts-var-liveboard-header-badge-modified-background':
    'var(--ts-var-button--secondary-background)',
  '--ts-var-liveboard-header-badge-modified-font-color': 'var(--ts-var-button--secondary-color)',
  '--ts-var-liveboard-header-badge-hover-color': 'var(--ts-var-button--primary--hover-background)',
  '--ts-var-liveboard-header-badge-active-color':
    'var(--ts-var-button--primary--active-background)',
  '--ts-var-viz-title-color': 'var(--ts-var-root-color)',
  '--ts-var-viz-title-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-viz-title-text-transform': 'var(--ts-var-root-text-transform)',
  '--ts-var-viz-description-color': 'var(--ts-var-root-color)',
  '--ts-var-viz-description-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-viz-description-text-transform': 'var(--ts-var-root-text-transform)',
  '--ts-var-viz-border-radius': 'initial',
  '--ts-var-viz-box-shadow': 'initial',
  '--ts-var-viz-background': 'initial',
  '--ts-var-viz-legend-hover-background': 'initial',
  '--ts-var-kpi-hero-color': 'initial',
  '--ts-var-kpi-comparison-color': 'initial',
};
